import { Box } from "@mui/material";
import { useLiveEventsContext } from "context/LiveEventsContext";
import { ConnectionStatus, EventTimeline } from "./components";
import SafeBoundary from "./components/SafeBoundary";

const LiveEventTracking = () => {
  const { isConnected, events, connectionError, clearEvents } =
    useLiveEventsContext();

  return (
    <Box ml={8} mr={8} mt={4}>
      <SafeBoundary name="LiveEventTracking">
        <EventTimeline
          events={events}
          isConnected={isConnected}
          connectionError={connectionError}
        />
      </SafeBoundary>

      <ConnectionStatus onClear={clearEvents} />
    </Box>
  );
};

export default LiveEventTracking;
